import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  TextField,
  Button,
} from '@mui/material';
import {
  ThumbUp,
  Speed,
} from '@mui/icons-material';

const UXTestPage: React.FC = () => {
  const [testData, setTestData] = useState({
    codigo: '',
    nombre: '',
    descripcion: '',
  });

  const fillWithGoodContent = () => {
    setTestData({
      codigo: 'PROD-2024.V1',
      nombre: 'Producto Premium & Especializado',
      descripcion: 'Descripción completa: Este es un producto excelente (100% garantizado) para empresas S.A.S',
    });
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* HEADER */}
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography variant="h3" gutterBottom sx={{ color: 'primary.main', fontWeight: 700 }}>
          📝 Formulario Simplificado
        </Typography>
        <Typography variant="h6" color="text.secondary">
          Sin validaciones de seguridad complejas - Campos normales
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 4, flexDirection: { xs: 'column', md: 'row' } }}>
        {/* FORMULARIO DE PRUEBA */}
        <Box sx={{ flex: 1 }}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Speed color="primary" />
                Campos de Entrada Simples
              </Typography>

              <Button 
                variant="contained" 
                onClick={fillWithGoodContent}
                sx={{ mb: 3 }}
                startIcon={<ThumbUp />}
              >
                Llenar con Contenido de Ejemplo
              </Button>

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                  fullWidth
                  label="Código del Producto"
                  value={testData.codigo}
                  onChange={(e) => setTestData(prev => ({ ...prev, codigo: e.target.value }))}
                  placeholder="Ejemplo: PROD-2024.V1"
                />

                <TextField
                  fullWidth
                  label="Nombre del Producto"
                  value={testData.nombre}
                  onChange={(e) => setTestData(prev => ({ ...prev, nombre: e.target.value }))}
                  placeholder="Ejemplo: Producto Premium & Especializado"
                />

                <TextField
                  fullWidth
                  label="Descripción"
                  value={testData.descripcion}
                  onChange={(e) => setTestData(prev => ({ ...prev, descripcion: e.target.value }))}
                  multiline
                  rows={3}
                  placeholder="Ejemplo: Descripción completa con (paréntesis), acentos áéíóú y más..."
                />
              </Box>
            </CardContent>
          </Card>
        </Box>

        {/* INFORMACIÓN */}
        <Box sx={{ flex: 1 }}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: 'success.main' }}>
                ✅ Campos Simplificados
              </Typography>
              
              <Typography variant="body2" sx={{ mb: 2 }}>
                Ahora puedes escribir cualquier texto sin restricciones de seguridad:
              </Typography>

              <Box sx={{ mb: 3, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  • Caracteres especiales: ()&@#$%
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  • Acentos: áéíóúñü
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  • Espacios y puntuación
                </Typography>
                <Typography variant="body2">
                  • Sin límites estrictos
                </Typography>
              </Box>

              <Typography variant="h6" gutterBottom sx={{ color: 'info.main' }}>
                📋 Instrucciones
              </Typography>
              
              <Typography variant="body2" sx={{ mb: 2 }}>
                1. Haz clic en "Llenar con Contenido de Ejemplo"
              </Typography>
              
              <Typography variant="body2" sx={{ mb: 2 }}>
                2. Escribe cualquier texto que desees
              </Typography>
              
              <Typography variant="body2">
                3. Los campos funcionan como TextField normales de Material-UI
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Container>
  );
};

export default UXTestPage; 